import { CategoryEnum, ActionsEnum } from '@academica-box/analytics/events/index'
import type {
  CatalogShowCard,
  CatalogClickCard,
  CatalogClickMenu,
  CatalogShowFilterPartner,
  CatalogClickFilterPartner,
  CatalogShowFilterTypeOfStudy,
  CatalogClickFilterTypeOfStudy,
  CatalogShowFilterLevel,
  CatalogClickFilterLevel,
  CatalogShowFilterDuration,
  CatalogClickFilterDuration,
  CatalogShowFilterPrice,
  CatalogClickFilterPrice,
  CatalogShowFilterLanguage,
  CatalogClickFilterLanguage,
  CatalogClickCoursesSorting,
} from '@academica-box/analytics/events/catalog'
import { useDirectionsStore } from '@academica-box/composables/store/directions'
import { storeToRefs } from 'pinia'

export const sendCatalogShowCard = (context: CatalogShowCard['context']) => {
  const { $analytics } = useNuxtApp()
  const directionsStore = useDirectionsStore()
  const { activeDirection, activeSection } = storeToRefs(directionsStore)

  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.show_card,
    context: {
      direction_id: activeDirection.value?.slug ?? 'none',
      topics_id: activeSection.value?.slug ?? 'none',
      ...context,
    },
  })
}

export const sendCatalogClickCard = (context: CatalogClickCard['context']) => {
  const { $analytics } = useNuxtApp()
  const directionsStore = useDirectionsStore()
  const { activeDirection, activeSection } = storeToRefs(directionsStore)

  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.click_card,
    context: {
      direction_id: activeDirection.value?.slug ?? 'none',
      topics_id: activeSection.value?.slug ?? 'none',
      ...context,
    },
  })
}

export const sendCatalogShowMenu = () => {
  const { $analytics } = useNuxtApp()
  const directionsStore = useDirectionsStore()
  const { activeDirection, activeSection } = storeToRefs(directionsStore)

  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.show_menu,
    label: 'body',
    context: {
      direction_id: activeDirection.value?.slug ?? 'none',
      topics_id: activeSection.value?.slug ?? 'none',
    },
  })
}

export const sendCatalogClickMenu = (label: CatalogClickMenu['label'], context: CatalogClickMenu['context']) => {
  const { $analytics } = useNuxtApp()
  const directionsStore = useDirectionsStore()
  const { activeDirection, activeSection } = storeToRefs(directionsStore)

  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.click_menu,
    label,
    context: {
      direction_id: activeDirection.value?.slug ?? 'none',
      topics_id: activeSection.value?.slug ?? 'none',
      ...context,
    },
  })
}

export const sendCatalogShowSmallBanner = () => {
  const { $analytics } = useNuxtApp()
  const directionsStore = useDirectionsStore()
  const { activeDirection, activeSection } = storeToRefs(directionsStore)

  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.show_small_banner,
    context: {
      direction_id: activeDirection.value?.slug ?? 'none',
      topics_id: activeSection.value?.slug ?? 'none',
    },
  })
}

export const sendCatalogClickSmallBanner = () => {
  const { $analytics } = useNuxtApp()
  const directionsStore = useDirectionsStore()
  const { activeDirection, activeSection } = storeToRefs(directionsStore)

  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.click_small_banner,
    context: {
      direction_id: activeDirection.value?.slug ?? 'none',
      topics_id: activeSection.value?.slug ?? 'none',
    },
  })
}

export const sendCatalogShowFilterPartner = (context: CatalogShowFilterPartner['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.show_filter_partner,
    context,
  })
}

export const sendCatalogClickFilterPartner = (context: CatalogClickFilterPartner['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.click_filter_partner,
    context,
  })
}

export const sendCatalogShowFilterTypeOfStudy = (context: CatalogShowFilterTypeOfStudy['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.show_filter_type_of_study,
    context,
  })
}

export const sendCatalogClickFilterTypeOfStudy = (context: CatalogClickFilterTypeOfStudy['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.click_filter_type_of_study,
    context,
  })
}

export const sendCatalogShowFilterLevel = (context: CatalogShowFilterLevel['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.show_filter_level,
    context,
  })
}

export const sendCatalogClickFilterLevel = (context: CatalogClickFilterLevel['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.click_filter_level,
    context,
  })
}

export const sendCatalogShowFilterDuration = (context: CatalogShowFilterDuration['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.show_filter_duration,
    context,
  })
}

export const sendCatalogClickFilterDuration = (context: CatalogClickFilterDuration['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.click_filter_duration,
    context,
  })
}

export const sendCatalogShowFilterPrice = (context: CatalogShowFilterPrice['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.show_filter_price,
    context,
  })
}

export const sendCatalogClickFilterPrice = (context: CatalogClickFilterPrice['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.click_filter_price,
    context,
  })
}

export const sendCatalogShowFilterLanguage = (context: CatalogShowFilterLanguage['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.show_filter_language,
    context,
  })
}

export const sendCatalogClickFilterLanguage = (context: CatalogClickFilterLanguage['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.click_filter_language,
    context,
  })
}

export const sendCatalogShowCoursesSorting = () => {
  const { $analytics } = useNuxtApp()
  const directionsStore = useDirectionsStore()
  const { activeDirection, activeSection } = storeToRefs(directionsStore)

  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.show_courses_sorting,
    context: {
      direction_id: activeDirection.value?.slug ?? 'none',
      topics_id: activeSection.value?.slug ?? 'none',
    },
  })
}

export const sendCatalogClickCoursesSorting = (context: CatalogClickCoursesSorting['context']) => {
  const { $analytics } = useNuxtApp()
  const directionsStore = useDirectionsStore()
  const { activeDirection, activeSection } = storeToRefs(directionsStore)

  $analytics?.push({
    category: CategoryEnum.Catalog,
    action: ActionsEnum.click_courses_sorting,
    context: {
      direction_id: activeDirection.value?.slug ?? 'none',
      topics_id: activeSection.value?.slug ?? 'none',
      ...context,
    },
  })
}
